import React, { Component } from "react";

class OurTeams extends Component {
    render() {
        return (
            <section className='section cm-services cm-services-02' >
                <iframe title="teams" src="https://centrisportivi.gesosport.it/view/#/corsifromiframe/eyJpZF9zb2NpZXRhIjogNjcsImJhY2tncm91bmRjb2xvciI6IiNGRjAwMDAiLCJhbm5vZ2VzdGlvbmUiOjIwMjN9" width="100%" height="800px" frameborder="0"></iframe>
            </section >
        );
    }
}

export default OurTeams;

